import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from "@mui/material";
import PropTypes from "prop-types";
import SlideUpTransition from "../components/fundamentals/SlideUpTransition";

const EmployeeTimeOffWOPMobilePageFilterDialog = (props) => {
  return (
    <Dialog
      fullScreen
      className="detail-dialog"
      fullWidth
      maxWidth="md"
      TransitionComponent={SlideUpTransition}
      open={props.isMobileFilterDialogOpen}
      onClose={props.handleClickMobileFilterDialogClose.bind(this)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle sx={{ fontWeight: "bold", marginLeft: "15px" }} id="alert-dialog-slide-title">
        Filters
      </DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <div style={{ margin: "15px" }}>
            <Box>{props.stationSelect}</Box>
          </div>
          <div style={{ margin: "15px" }}>
            <Box>{props.workgroupSelect}</Box>
          </div>
          <div style={{ margin: "15px" }}>
            <Box>{props.wopTypeSelect}</Box>
          </div>
          <div style={{ margin: "15px" }}>
            <Box>{props.dateSelect}</Box>
          </div>
          <div style={{ margin: "15px" }}>
            <Box>{props.statusSelect}</Box>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="flex-end" alignItems={"center"} spacing={1}>
          <Grid item>
            <Button
              variant="contained"
              onClick={props.handleClickMobileFilterDialogApplyFiltersButton.bind(this)}
              disabled={props.selectedWopType === "" || !props.selectedDate}
            >
              Apply Filters
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

EmployeeTimeOffWOPMobilePageFilterDialog.propTypes = {
  stationSelect: PropTypes.element.isRequired,
  workgroupSelect: PropTypes.element.isRequired,
  wopTypeSelect: PropTypes.element.isRequired,
  dateSelect: PropTypes.element.isRequired,
  statusSelect: PropTypes.element.isRequired,
  selectedWopType: PropTypes.string.isRequired,
  selectedDate: PropTypes.object,
  handleClickMobileFilterDialogApplyFiltersButton: PropTypes.func.isRequired,
  handleClickMobileFilterDialogClose: PropTypes.func.isRequired,
  isMobileFilterDialogOpen: PropTypes.bool.isRequired,
};

export default EmployeeTimeOffWOPMobilePageFilterDialog;
